import { useEffect } from 'react'
import { usePromise } from 'shared/hooks/usePromise'
import { useStreamerConfigContext } from '@/contexts/StreamerConfigContext/StreamerConfigContext'
import { getConvertedAmount } from '@/pages/Donation/utils'

interface Props {
  initialAmount: string
  onSetCryptoAmount: (amount: string) => void
  baseCurrencyCode?: string
  cryptoAssetCode?: string
}

export const useInitialConvertAmount = ({
  initialAmount,
  onSetCryptoAmount,
  cryptoAssetCode,
  baseCurrencyCode,
}: Props) => {
  const { username = '' } = useStreamerConfigContext()
  const { send: convertAmount } = usePromise(getConvertedAmount, {
    onSuccess: amount => {
      if (amount) {
        onSetCryptoAmount(amount)
      }
    },
  })

  useEffect(() => {
    if (cryptoAssetCode && baseCurrencyCode && initialAmount) {
      convertAmount({
        amount: initialAmount,
        currencyFrom: baseCurrencyCode,
        currencyTo: cryptoAssetCode,
        username,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [baseCurrencyCode, cryptoAssetCode, initialAmount, username])
}
